export enum CasinoSectionType {
  CASINO = 'casino',
  ZINGA = 'zinga',
  FAVORITES = 'favorites',
}
